import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import {Box, MainHeading, Description} from '../../StyledComponents';
import _ from 'lodash';
import 'rc-slider/assets/index.css';

const PositioningMatrixContainer = styled.div`
  position:relative;
  display: flex;
  min-height:185px;
  min-height: 25vh;
`;

const PositioningMatrix = styled.div`
  position:absolute;
  display: flex;
  top:20px;
  bottom:20px;
  left:120px;
  right:120px;

  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    background: #fff;
    height:1px;
    width:100%;
    top:50%;
  }
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: #fff;
    height:100%;
    width:1px;
    left:50%;
  }
`;


const AxesLabel = styled.span`
  position: absolute;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: bold;

  ${props => props.HighX && css`
    top:50%;
    right:0;
    transform:translateY(-50%);
    color: #49a184;
  `}
  ${props => props.LowX && css`
    top:50%;
    left:0;
    transform:translateY(-50%);
    color: #49a184;
  `}
  ${props => props.HighY && css`
    top:0;
    left:50%;
    transform:translateX(-50%);
    color: #376176;
  `}
  ${props => props.LowY && css`
    bottom:0;
    left:50%;
    transform:translateX(-50%);
    color: #376176;
  `}
`;


const Variable = styled.span`
  position: absolute;
  text-transform: uppercase;
  border:1px solid #fff;
  border-radius: 50px;
  padding: 3px 7px;
  font-size: 11px;
  background: #000;
  cursor: pointer;
  width: 84px;
  text-align: center;

  &:hover {
    background: #000;
    z-index:999;
  }
`;

class KeyDrivers extends Component {
    isValidNumber(number) {
      return typeof(number) === 'number' && !isNaN(number)
    }

    renderVariables(data) {
      const variableNames=["price","product","promotion","preference","proposal","people"];
      let output = [];

      let min = 100;
      let max = 0;
      let total = 0;
      let weightTotal = 0;
      let weightAverage = 0;
      let activeVarCount = 0;

      variableNames.forEach(v => {
        const varData = data[v];

        if (varData && varData.inactive != true) {

          activeVarCount++;
          total = parseFloat(total) + parseFloat(varData.weight);
          if (varData.weight < min) {
            min = varData.weight
          }
          if (varData.weight > max) {
            max = varData.weight
          }

          if (this.isValidNumber(parseFloat(varData.weight))) {
            weightTotal = parseFloat(weightTotal)+parseFloat(varData.weight);
            weightAverage = weightTotal/activeVarCount;
          }
        }

      });

      const average = total/variableNames.length;
      const deviation = average/50;

      // Build sorted arrays of only active vars
      let varsByImpact = [];
      let varsByPotential = [];
      _.forEach(variableNames, function(variable, i) {
        const varData = data[variable];
        if (varData && varData.inactive != true) {
          varsByImpact.push(varData);
          varsByPotential.push(varData);
        }
      });

      // Build sorted arrays of only active vars
      varsByImpact = varsByImpact.sort(function(a, b) {
        return a.weight - b.weight;
      });
      const varsByImpactIds=[];
      varsByImpact.forEach(v => {
        varsByImpactIds.push(v.id);
      });

      varsByPotential = varsByPotential.sort(function(a, b) {
        return a.potential - b.potential;
      });


      const varsByPotentialIds=[];
      varsByPotential.forEach(v => {
        varsByPotentialIds.push(v.id);
      });

      let totalScore = [];
      _.forEach(variableNames, function(variable, i) {
        totalScore.push({name: variable, score: varsByPotentialIds.indexOf(variable) /* + varsByImpactIds.indexOf(variable)*/})
      })

      totalScore = _.orderBy(totalScore, 'score', 'desc');
      //const numberToShow = 4;
      const numberToHide = 3;
      let pickedVars = totalScore.splice(0, totalScore.length-numberToHide);
      pickedVars = _.map(pickedVars, 'name');

      _.forEach(variableNames, function(variable, i) {
        const varData = data[variable];

        if (varData && varData.inactive != true) {
          const paddedMax = max;
          const weightFactor = (varData.weight/paddedMax)*100 - 50;
          const spread = 10;

          const impactIndex = (varsByImpactIds.indexOf(varData.id)+1)/(varsByImpact.length/2);
          const impactPos = 10 + 50*(0.5*impactIndex);

          const scoreIndex = (varsByPotentialIds.indexOf(varData.id)+1)/(varsByPotential.length/2);
          const scorePos = 10 + 50*(0.5*scoreIndex);
          const numberOfVars = varsByImpactIds.length;


          if (pickedVars.indexOf(variable) > -1) {
            output.push(<Variable key={i} style={{bottom:(impactPos||0)+"%", left:scorePos+"%"}}>{varData.name}</Variable>);
          }
        }
      });

      return output;
    }

    render() {
      const { note, data, propData, printBreak } = this.props;
      const simulationMode = data.simulationMode;

      /*
      const variables = [
        {title: 'Perception', impact:'20', score:'30'},
        {title: 'Perception', impact:'74', score:'10'},
        {title: 'Perception', impact:'30', score:'20'},
        {title: 'Perception', impact:'50', score:'50'},
      ];
      */

      const placeholderData = {
        title: "Category key areas",
        description: "Key category drivers",
        variables: propData
      };

      const _data = propData || {};
      const componentData = placeholderData;
      _data.keyAttributes = placeholderData;

      return (
        <Box className={this.props && this.props.className + ' ' + printBreak ? 'print-page-break-after' : ''} contentHeight={this.props.contentHeight}>
            {/* <ReportHeading>{componentData.title}</ReportHeading> */}
            <MainHeading>{this.props.title || componentData.title}</MainHeading>

            {(componentData.description && <Description>{componentData.description}</Description>) || null}

            <PositioningMatrixContainer>
              <AxesLabel HighX>High potential</AxesLabel>
              <AxesLabel LowX>Low potential</AxesLabel>
              <AxesLabel HighY>High impact</AxesLabel>
              <AxesLabel LowY>Low impact</AxesLabel>
                <PositioningMatrix>
                  {this.renderVariables(_data)}
                </PositioningMatrix>
            </PositioningMatrixContainer>
        </Box>
      );

    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data
    };
}

export default connect(mapStateToProps)(KeyDrivers);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/KeyDrivers.js